// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__iO0Mc","overlay":"Modal_overlay__EH+qT","content":"Modal_content__XSe0w"};